var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "section-head" }, [_vm._v("规则配置")]),
      _c("div", { staticClass: "rule-block" }, [
        _c(
          "div",
          {
            staticClass: "status-tip",
            staticStyle: { "margin-bottom": "8px" },
          },
          [_vm._v("有效人数计算规则")]
        ),
        _c(
          "div",
          { staticClass: "rule-row" },
          [
            _c(
              "el-checkbox",
              {
                staticStyle: {
                  "margin-bottom": "18px",
                  width: "168px",
                  "text-align": "right",
                },
                model: {
                  value: _vm.localForm.agentBoxRuleFlags.bet,
                  callback: function ($$v) {
                    _vm.$set(_vm.localForm.agentBoxRuleFlags, "bet", $$v)
                  },
                  expression: "localForm.agentBoxRuleFlags.bet",
                },
              },
              [_vm._v(" 累计投注达到 ")]
            ),
            _c("el-input-number", {
              staticClass: "rule-input-num",
              attrs: {
                size: "mini",
                min: 0,
                precision: 2,
                controls: false,
                disabled: !_vm.localForm.agentBoxRuleFlags.bet,
              },
              model: {
                value: _vm.localForm.agentBoxRuleValues.bet_amount,
                callback: function ($$v) {
                  _vm.$set(_vm.localForm.agentBoxRuleValues, "bet_amount", $$v)
                },
                expression: "localForm.agentBoxRuleValues.bet_amount",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "rule-row" },
          [
            _c(
              "el-checkbox",
              {
                staticStyle: {
                  "margin-bottom": "18px",
                  width: "168px",
                  "text-align": "right",
                },
                model: {
                  value: _vm.localForm.agentBoxRuleFlags.payin,
                  callback: function ($$v) {
                    _vm.$set(_vm.localForm.agentBoxRuleFlags, "payin", $$v)
                  },
                  expression: "localForm.agentBoxRuleFlags.payin",
                },
              },
              [_vm._v(" 累计存款达到 ")]
            ),
            _c("el-input-number", {
              staticClass: "rule-input-num",
              attrs: {
                size: "mini",
                min: 0,
                precision: 2,
                controls: false,
                disabled: !_vm.localForm.agentBoxRuleFlags.payin,
              },
              model: {
                value: _vm.localForm.agentBoxRuleValues.payin_amount,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.localForm.agentBoxRuleValues,
                    "payin_amount",
                    $$v
                  )
                },
                expression: "localForm.agentBoxRuleValues.payin_amount",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "section-head" }, [_vm._v("邀请档位设置")]),
      _c(
        "el-form-item",
        { attrs: { "label-width": "100px", label: "奖励稽核倍数" } },
        [
          _c("el-input-number", {
            staticClass: "rule-input-num",
            attrs: { min: 0, precision: 2, controls: false },
            model: {
              value: _vm.localForm.agentBoxRuleValues.multiple,
              callback: function ($$v) {
                _vm.$set(_vm.localForm.agentBoxRuleValues, "multiple", $$v)
              },
              expression: "localForm.agentBoxRuleValues.multiple",
            },
          }),
          _c("span", { staticClass: "rule-suffix" }, [_vm._v("倍")]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "red-tiers-actions" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _setup.addTier },
            },
            [_vm._v("新增")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "status-tip", staticStyle: { "margin-bottom": "8px" } },
        [_vm._v("保存时将按邀请有效人数从小到大排序")]
      ),
      _c(
        "el-table",
        {
          staticClass: "tier-table",
          attrs: {
            data: _vm.localForm.agentBoxTiers,
            border: "",
            size: "mini",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "序号", width: "56", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(scope.$index + 1))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "累计有效人数", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          gap: "6px",
                        },
                      },
                      [
                        _c("span", { staticClass: "tier-gte-prefix" }, [
                          _vm._v("≥"),
                        ]),
                        _c("el-input-number", {
                          staticStyle: { width: "90px" },
                          attrs: {
                            min: 1,
                            precision: 0,
                            controls: false,
                            size: "mini",
                          },
                          model: {
                            value: scope.row.need_share_one_num,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "need_share_one_num", $$v)
                            },
                            expression: "scope.row.need_share_one_num",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "奖励类型", "min-width": "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "120px" },
                        attrs: { size: "mini" },
                        on: {
                          change: function ($event) {
                            return _setup.onRewardTypeChange(scope.$index)
                          },
                        },
                        model: {
                          value: scope.row.reward_type,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "reward_type", $$v)
                          },
                          expression: "scope.row.reward_type",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: {
                            label: "随机奖励",
                            value: _setup.REWARD_RANDOM,
                          },
                        }),
                        _c("el-option", {
                          attrs: {
                            label: "固定奖励",
                            value: _setup.REWARD_FIXED,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "奖励金额", "min-width": "220" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    Number(scope.row.reward_type) === _setup.REWARD_RANDOM
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              gap: "6px",
                            },
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "92px" },
                              attrs: {
                                min: 0,
                                precision: 2,
                                controls: false,
                                size: "mini",
                              },
                              model: {
                                value: scope.row.reward_count_min,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "reward_count_min", $$v)
                                },
                                expression: "scope.row.reward_count_min",
                              },
                            }),
                            _c("span", { staticClass: "rule-suffix" }, [
                              _vm._v("~"),
                            ]),
                            _c("el-input-number", {
                              staticStyle: { width: "92px" },
                              attrs: {
                                min: 0,
                                precision: 2,
                                controls: false,
                                size: "mini",
                              },
                              model: {
                                value: scope.row.reward_count_max,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "reward_count_max", $$v)
                                },
                                expression: "scope.row.reward_count_max",
                              },
                            }),
                          ],
                          1
                        )
                      : _c("el-input-number", {
                          staticStyle: { width: "120px" },
                          attrs: {
                            min: 0,
                            precision: 2,
                            controls: false,
                            size: "mini",
                          },
                          model: {
                            value: scope.row.reward_count,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "reward_count", $$v)
                            },
                            expression: "scope.row.reward_count",
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "已发放", width: "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(scope.row.available_num))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "72", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "danger-button",
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _setup.removeTier(scope.$index)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }